export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <svg width="30" height="30" viewBox="0 0 64 64" data-testid="logo-mark" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={light ? "#FAF8F5" : "#161514"} />
        <path
          d="M20 47V29a12 12 0 0 1 24 0v18"
          fill="none"
          stroke="#C85A32"
          strokeWidth="5"
          strokeLinecap="round"
        />
        <line x1="15" y1="47" x2="49" y2="47" stroke="#B88E4C" strokeWidth="5" strokeLinecap="round" />
      </svg>
      <span
        className={`font-serif text-xl font-semibold tracking-tight ${
          light ? "text-[#FAF8F5]" : "text-[#1A1918]"
        }`}
      >
        Ristruttura<span className="text-[#C85A32]">Casa</span>
      </span>
    </span>
  );
}
